var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenEllipseBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 613,
    height: 889,
    viewBox: "0 0 613 889",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_f_2014_1375)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.9454,
    cy: 444.379,
    rx: 605,
    ry: 292,
    transform: "rotate(30 18.9454 444.379)",
    fill: "#04BA96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2014_1375",
    x: -575.1,
    y: 0.0929565,
    width: 1188.09,
    height: 888.573,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_2014_1375"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenEllipseBottom);
export default __webpack_public_path__ + "static/media/GreenEllipseBottom.d54702d13f52ae1254509a2581464f08.svg";
export { ForwardRef as ReactComponent };